/**
 * Send data to an endpoint URL via a form submit like in the old days
 * @param data the data to send
 * @param actionUrl the endpoint URL
 * @param target the window target. '_self' results in a hard html request, leaving the current application
 * @param method POST or GET
 */
export const submitAsFormData = (
	data: { [key: string]: string | number },
	actionUrl: string = '/',
	target: '_self' | '_blank' = '_self',
	method: 'POST' | 'GET' = 'POST'
): void => {
	const form = document.createElement('form');
	form.action = actionUrl;
	form.target = target;
	form.method = method;

	for (const [key, val] of Object.entries(data)) {
		const formInput = document.createElement('input');
		formInput.type = 'hidden';
		formInput.name = key;
		formInput.value = val.toString();
		form.appendChild(formInput);
	}

	document.body.appendChild(form);
	form.submit();
};
